module.exports = __webpack_public_path__ + "img/imgslid.95dabc66.png";